/**
 * LayerType type.
 */
export enum LayerType {
  PRECOMPOSITION = 0,
  SOLID = 1,
  IMAGE = 2,
  GROUP = 3,
  SHAPE = 4,
  TEXT = 5,
  AUDIO = 6,
  VIDEO_PLACEHOLDER = 7,
  IMAGE_SEQUENCE = 8,
  VIDEO = 9,
  IMAGE_PLACEHOLDER = 10,
  GUIDE = 11,
  ADJUSTMENT = 12,
  CAMERA = 13,
  LIGHT = 14,
}
